export default {
  title: 'Installations',
  form: {
    subtitle: 'Technical field report — visit details and hardware.',
    devices: 'Devices',
    installedEquipment: 'Devices',
    deviceUsed: 'Used',
    deviceUsedHint: 'Turn on if this device was used on this installation.',
    salesDevice: 'Sales',
  },
  assign: {
    title: 'Assign Installation',
    description: 'This page will contain a form for assigning new installations or reassigning existing ones.'
  },
  actions: {
    assign: 'Assign Installation',
    update: 'Update/Approve',
    copyId: 'Copy Installation ID',
    remove: 'Remove Installation',
    createppoe: 'Create PPOE'
  },
  status: {
    awaiting: 'Awaiting',
    pending: 'Pending',
    inProgress: 'In Progress',
    done: 'Done',
    failed: 'Failed'
  },
  types: {
    all: 'All',
    installation: 'Installation',
    troubleshooting: 'Troubleshooting',
    installers: 'Installers',
    feedback: 'Feedback'
  },
  notAvailable: '—',
  yes: 'Yes',
  no: 'No',
  columns: {
    customer: 'Customer',
    createdBy: 'Created by',
    installer: 'Installer',
    status: 'Status',
    nocApproved: 'NOC approval',
    devices: 'Devices',
    type: 'Type',
    result: 'Results',
    photos: 'Photos'
  },
  installerDetails: {
    title: 'Installer',
    name: 'Name',
    email: 'Email',
    branch: 'Branch',
    role: 'Role',
    notAssigned: 'Not assigned',
    assignedAt: 'Assigned At',
    assignedDateTime: 'Assigned Date & Time',
  },
  nocApproved: {
    yes: 'Yes',
    no: 'No',
  },
  customerDetails: {
    title: 'Customer Details',
    id: 'Contract ID',
    nameEn: 'Name (EN)',
    nameFa: 'Name (FA)',
    company: 'Company',
    type: 'Customer type',
    email: 'Email',
    address: 'Address',
    phone: 'Phone',
    mobile: 'Mobile',
    contractNote: 'Contract Note'
  },
  resultDetails: {
    title: 'Installation results'
  },
  approve: {
    statusRequiredTitle: 'Cannot approve yet',
    statusRequiredBody: 'Set installation status to Done or Failed before approving.',
    confirmTitle: 'Approve installation?',
    confirmBody: 'Mark this installation as approved?',
    confirmDevicesSyncIntro: 'Equipment does not match the customer record.',
    confirmDevicesSyncFooter: 'Do you want to approve this installation?',
    diffAdded: '+ {name} × {qty}',
    diffRemoved: '− {name} × {qty}',
    diffQtyChanged: '{name}: {fromQty} → {toQty}',
    cancel: 'Cancel',
    successTitle: 'Approved',
    successBody: 'Installation approved successfully.',
    errorTitle: 'Approval failed',
    errorBody: 'Could not approve this installation.',
  },
  deviceDetails: {
    title: 'Devices',
    name: 'Name',
    quantity: 'Quantity',
    noDevices: 'No devices',
    count: '{n} device(s)'
  },
  notifications: {
    idCopied: {
      title: 'Installation ID Copied',
      description: 'The installation ID has been copied to your clipboard.'
    },
    deleted: {
      title: 'Installation Deleted',
      description: 'The installation has been successfully deleted.'
    },
    ppoeCreated: {
      title: 'PPOE Created',
      description: 'ppoe account has been successfully created.'
    },
    error: {
      title: 'Error',
      description: 'Failed to delete the installation. Please try again.'
    }
  }
} 